module.exports = __webpack_public_path__ + "img/ganan_yes.80095a59.png";